import axios from "axios";

// Register a new user (JSON data)
export const registerUser = async (formData) => {
  return await axios.post('https://glowtechbackend.in-sciencelabs.com/register', formData, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
};
